import styled from "@emotion/styled";

import RedBalloon from "./red-balloon.svg";
import YellowBalloon from "./yellow-balloon.svg";

export const StyledRedBalloon = styled(RedBalloon)``;

export const StyledYellowBalloon = styled(YellowBalloon)``;

export const Container = styled.div`
  ${StyledRedBalloon} {
    position: relative;
    inset-block-start: 84px;
  }

  ${StyledYellowBalloon} {
    position: relative;
    inset-inline-start: -32px;
  }
`;
